// API 환경 설정
const isDevelopment = process.env.NODE_ENV === "development";
// 현재 환경 정보 출력 (개발 시 확인용)
// console.log(
//   `현재 API 환경: ${isDevelopment ? "개발(Development)" : "배포(Production)"}`
// );

// API 기본 URL
const BASE_API_URL = isDevelopment
  ? "https://lawsuit.aitheh.com"
  : "https://lawsuit.aitheh.com";

// 쿠키 관련 설정
const COOKIE_CONFIG = {
  // 쿠키 키 이름
  KEYS: {
    ACCESS_TOKEN: "auth_token",
    REFRESH_TOKEN: "refresh_token",
    USER_INFO: "user_info",
  },

  // 쿠키 만료 시간 (일 단위)
  EXPIRES: {
    ACCESS_TOKEN: 1,
    REFRESH_TOKEN: 30,
    USER_INFO: 7,
  },
  // 쿠키 옵션
  OPTIONS: {
    path: "/",
    secure: !isDevelopment, // 개발 환경에서는 false, 배포 환경에서는 true
    sameSite: "strict",
  },
};

// 각 API 엔드포인트
const API_ENDPOINTS = {
  // 현재 환경 (개발/배포)
  IS_DEVELOPMENT: isDevelopment,

  // 기본 URL (다른 곳에서 필요할 경우)
  BASE_URL: BASE_API_URL,

  // 쿠키 설정
  COOKIE_CONFIG,

  // 엔드포인트
  auth: `/auth`,
  users: `/users`,
  cases: `/cases`,
  payments: `/payments`,
  verification: `/verification`,
  status: `/status`,

  // API 전체 URL 가져오기 (prefix 자동 추가)
  getApiUrl: (endpoint) => `${BASE_API_URL}${endpoint}`,
};

export default API_ENDPOINTS;
